import { z } from 'zod';

import { RowLevelEnum } from './rowLevel.js';

export const StartPushTrackerMappingsRequestSchema = z.object({
  settingsId: z.string(),
  rowLevel: RowLevelEnum.nullish(),
  rowLevelId: z.string().nullish(),
  rowLevelExternalId: z.string().nullish(),
  trackerMappingId: z.string().nullish(),
});

export type StartPushTrackerMappingsRequest = z.infer<
  typeof StartPushTrackerMappingsRequestSchema
>;
